import HttpService from "../../../services/HttpService";
import IEmployee from "../models/IEmployee";
import IEmployeesResponse from "../models/IEmployeesSearch";

export async function getEmployeesByCode(employeeCodesProp: string): Promise<IEmployee[]> {
    try {
        const employeeCodes = employeeCodesProp.split(',').map(employee => employee.trim()).filter(employee => employee);

        const employees = await Promise.all(employeeCodes.map(employeeCode => {
            return HttpService.get<IEmployee>(
                `${process.env.GATSBY_API_URL}/table/employees/${employeeCode}`,
                null
            );
        }));
        return employees.filter(employee => employee); // filters out empty values
    } catch (err) {
        console.error("Error retrieving employees by code", err);
        return [];
    }
}

export async function searchEmployees(latitude: number, longitude: number, radius: number, limit: number, department: string): Promise<IEmployeesResponse> {
    try {
        const { localEmployees, virtualEmployees, usedSearchRadius } = await HttpService.get<IEmployeesResponse>(`${process.env.GATSBY_API_URL}/employees/local-employees`,
            null,
            {
                params: {
                    latitude,
                    longitude,
                    radius,
                    department
                }
            });


        return {
            localEmployees: localEmployees.slice(0, limit),
            virtualEmployees: virtualEmployees.slice(0, limit),
            usedSearchRadius,
        };

    } catch (err) {
        console.error("Error retrieving local and virtual employees", err);
        return {
            localEmployees: [],
            virtualEmployees: [],
            usedSearchRadius: radius,
        };
    }
}
